<template>
    <Modal :removePadding="true" :narrow="false" :open="toggleModal" :show-close-icon="true" @close="dismissModal" :is-card="true" :close-has-background="true" :enable-inner="false">
        <template v-slot:image>
            <div class="reserve-online-modal__container">
                <div @click="reserveButtonClicked" class="reserve-online-modal__bg">
                    <picture>
                        <source
                            srcset="
                                /images/reserve-online/popup/reserve-online-logo.webp,
                                /images/reserve-online/popup/reserve-online-logo@2x.webp 2x
                            "
                            type="image/webp"
                        />
                        <img
                            srcset="
                                /images/reserve-online/popup/reserve-online-logo.png,
                                /images/reserve-online/popup/reserve-online-logo@2x.png 2x
                            "
                            alt="reserve online logo"
                            class="reserve-online-modal__logo"
                        />
                    </picture>
                </div>
                <div class="reserve-online-modal__body">
                    <div class="reserve-online-modal__body-item">
                        <h1 class="reserve-online-modal__body-h1">Reserve this vehicle today!</h1>
                        <p>
                            For a fully refundable £99 fee, reserve this {{ vehicle.manufacturer }} {{ vehicle.model }} today and we will ensure the vehicle is not sold before you get chance to see it.
                        </p>
                        <button class="btn btn--secondary reserve-online-modal__btn" @click="reserveButtonClicked">RESERVE ONLINE</button>
                    </div>
                </div>
            </div>
        </template>
    </Modal>
</template>

<script>
    import Modal from "../../../core/components/Modal.vue";
    import EventObject from "../../../modules/tracking/EventObject";

    export default {
        components: {
            Modal,
        },
        props: ["disabled", "vehicle"],

        data() {
            return {
                timeoutId: null,
                toggleModal: false,
            };
        },

        computed: {
            url() {
                return { name: "reserve-online-landing", params: { id: this.vehicle.id } };
            },
        },

        methods: {
            dismissModal() {
                this.toggleModal = false;
            },

            reserveButtonClicked() {
                new EventObject("Reserve Online Pop Up - Used Cars", "CTA Clicked", `Reserve Online Landing Page`).dispatch();
                this.$router.push(this.url)
            },
        },

        watch: {
            disabled: function () {
                if (this.timeoutId) {
                    clearTimeout(this.timeoutId);
                }
            },
        },

        mounted() {
            const viewHistory = JSON.parse(localStorage.getItem("usedVehicleViewHistory"));
            let timeoutDuration = 30000;

            if (viewHistory.hasOwnProperty(this.vehicle.id) && viewHistory[this.vehicle.id].views > 2) {
                timeoutDuration /= 2;
            }

            this.timeoutId = setTimeout(() => {
                this.toggleModal = true
                new EventObject("Reserve Online Pop Up - Used Cars", "Shown", `Reserve Online Landing Page`).dispatch();
            }, timeoutDuration);
        },

        beforeDestroy() {
            if (this.timeoutId) {
                clearTimeout(this.timeoutId);
            }
        },
    };
</script>

<style lang="scss">
@import "../../../../sass/redesign/modals/reserve-online-modal";
.remodal {
    max-width: 450px !important;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/ReserveOnline/ReserveOnlinePopup.vue